import { asyncRouterMap, constantRouterMap } from "@/router";
import { appendRouterMap } from "@/router/append";
import { $rrj } from "@/utils/rrjutils";

// /**
//  * 过滤路由表，返回符合用户角色权限的路由表
//  * @param roles
//  */
function filterAsyncRouter(modules) {
  const result = [asyncRouterMap[0]];
  modules = modules.filter((val) => val.title !== "首页");
  if (Array.isArray(modules) && modules.length > 0) {
    modules.forEach((module) => {
      asyncRouterMap.forEach((val) => {
        if (module.path === val.path) {
          if (module.children && module.children.length > 0) {
            const children = [];

            module.children.forEach((child) => {
              if (val.children) {
                const idx = val.children.findIndex(
                  (vChild) => vChild.path === child.path
                );

                if (idx !== -1) {
                  val.children[idx].meta.title = child.title;
                  children.push(val.children[idx]);
                } else {
                  console.log("child.name", child.name);
                }
              }
            });
            result.push({
              ...val,
              meta: { title: module.title, icon: module.icon },
              children: Array.from(new Set(children)),
            });
          }
          // else {
          //   if (module.title === "首页") {
          //     result.push(asyncRouterMap[0]);
          //   } else {
          //     // 一般不会走到这里 不然说明路由设置错误了
          //     result.push({ ...val, children: [] });
          //   }
          // }
        }
      });
    });
  }
  return result;
}

const permission = {
  state: {
    routers: [],
    addRouters: [],
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    },
  },
  actions: {
    // GenerateRoutes({ commit }, asyncRouterMap) {
    //   return new Promise((resolve) => {
    //     commit("SET_ROUTERS", asyncRouterMap);
    //     resolve();
    //   });
    // },
    GetAsyncRoutes({ state, commit }) {
      return new Promise((resolve) => {
        // let asyncRouter = [];

        // 处理子账号路由
        // if ($rrj.storage.get("_ukit").uuid.indexOf("child_") > -1) {
        // let modules = $rrj.storage.get("_module");
        //   modules = modules.sort((a, b) => a.id - b.id);
        //   asyncRouter = filterAsyncRouter(modules);
        // } else {
        //   asyncRouter = asyncRouterMap;
        // }
        // console.log(asyncRouterMap, "asyncRouter1");
        let modules = $rrj.storage.get("_module");
        let asyncRouter = filterAsyncRouter(modules);
        // console.log(asyncRouter, "asyncRouter");

        // 获取动态路由
        // commit("GenerateRoutes", asyncRouterMap);
        // console.log(appendRouterMap);
        // console.log(asyncRouterMap);
        let routes = asyncRouter.map((route) => {
          // console.log(appendRouterMap[route.path]);
          // const aaa = {
          //   ...route,
          //   // children: [...route.children, ...appendRouterMap[route.path]],
          // };
          // console.log(aaa);
          if (
            appendRouterMap[route.path] &&
            appendRouterMap[route.path].length > 0 &&
            route.children &&
            route.children.length > 0
          ) {
            return {
              ...route,
              children: [...route.children, ...appendRouterMap[route.path]],
            };
          }

          return route;
        });

        // console.log("GenerateRoutes", routes);

        // console.log("GenerateRoutes", asyncRouterMap);

        commit("SET_ROUTERS", routes);

        resolve(state.addRouters.length > 0);
        //   getAsyncRoute()
        //     .then((data) => {
        //       // setToken(data.token.id)
        //       // setRefreshToken(data.refresh_token)
        //       // commit('SET_TOKEN', data.token.id)
        //       // setUser(data.user)
        //       // commit('SET_USER', data.user)
        //       // commit('SET_NAME', data.user.nickname)
        //       commit("GenerateRoutes", asyncRouterMap);
        //       resolve();
        //     })
        // .catch((error) => {
        //   reject(error);
        // });
      });
    },
  },
};

export default permission;
